import {useState} from "react";

import ConfirmationPopup from "./components/ConfirmationPopup";
import ActionPanel from "./components/ActionPanel";
import TabButton from "./components/TabButton";

//import {aiUpdateDescription} from "api/product/enrichment";

import {
    TagIcon,
    ImageIcon,
    FileTextIcon,
    PaletteIcon,
    GlobeIcon,
    ScanIcon,
    SparkleIcon,
    UploadIcon,
    PenIcon,
    EyeIcon
} from "./components/icons";

import {fields, getFieldToEnrich} from "../EnrichmentTable/helpers/product";

export const tabIds = {
    TOUS: "tous",
    IMAGE: "image",
    DESCRIPTION: "description",
    COULEUR: "couleur",
    SEO: "seo",
    METATITLE: "metatitle",
    METADESC: "metadesc"
};

export const tabs = [
    {
        id: tabIds.TOUS,
        label: "Tous",
        count: 9,
        icon: <TagIcon/>,
        actions: null,
    },
    {
        id: tabIds.IMAGE,
        label: "Image",
        count: 2,
        icon: <ImageIcon/>,
        sectionLabel: "ACTIONS D'ENRICHISSEMENT — IMAGE",
        actions: [
            {id: "retrouver-image", icon: <ScanIcon/>, label: "Retrouver l'image"},
            {id: "homogeneisation-fond", icon: <SparkleIcon/>, label: "Homogénéisation du fond"},
            {id: "generation-produit-porte", icon: <ScanIcon/>, label: "Génération du produit porté"},
            {id: "ajout-manuel-image", icon: <UploadIcon/>, label: "Ajout manuel"},
        ],
    },
    {
        id: tabIds.DESCRIPTION,
        label: "Description",
        count: 2,
        icon: <FileTextIcon/>,
        sectionLabel: "ACTIONS D'ENRICHISSEMENT — DESCRIPTION",
        actions: [
            {id: "creation-description", icon: <PenIcon/>, label: "Création de la description"},
            {id: "enrichissement-seo", icon: <GlobeIcon/>, label: "Enrichissement SEO"},
            {id: "enrichissement-gso", icon: <GlobeIcon/>, label: "Enrichissement GSO"},
            {id: "ajout-manuel-description", icon: <PenIcon/>, label: "Ajout manuel description"},
        ],
    },
    {
        id: tabIds.COULEUR,
        label: "Couleur",
        count: 2,
        icon: <PaletteIcon/>,
        sectionLabel: "ACTIONS D'ENRICHISSEMENT — COULEUR",
        actions: [
            {id: "remplir-couleur", icon: <EyeIcon/>, label: "Remplir la couleur (lire l'image)"},
            {id: "ajout-manuel-couleur", icon: <PenIcon/>, label: "Ajout manuel de la couleur"},
        ],
    },
    {
        id: tabIds.SEO,
        label: "SEO",
        count: 1,
        icon: <GlobeIcon/>,
        sectionLabel: "ACTIONS D'ENRICHISSEMENT — SEO",
        actions: [
            {id: "seo-ia", icon: <SparkleIcon/>, label: "IA en fonction des attributs"},
            {id: "seo-manuel", icon: <PenIcon/>, label: "Manuel"},
        ],
    },
    {
        id: tabIds.METATITLE,
        label: "Meta Title",
        count: 1,
        icon: <GlobeIcon/>,
        sectionLabel: "ACTIONS D'ENRICHISSEMENT — META TITLE",
        actions: [
            {id: "metatitle-ia", icon: <SparkleIcon/>, label: "IA en fonction des attributs"},
            {id: "metatitle-manuel", icon: <PenIcon/>, label: "Manuel"},
        ],
    },
    {
        id: tabIds.METADESC,
        label: "Meta Description",
        count: 1,
        icon: <GlobeIcon/>,
        sectionLabel: "ACTIONS D'ENRICHISSEMENT — META DESCRIPTION",
        actions: [
            {id: "metadesc-ia", icon: <SparkleIcon/>, label: "IA en fonction des attributs"},
            {id: "metadesc-manuel", icon: <PenIcon/>, label: "Manuel"},
        ],
    },
];

export default function EnrichmentActions({selected = [], list, match, activeId, setActiveId, productsToBeEnriched = []}) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const activeTab = tabs.find((t) => t.id === activeId);

    const getDynamicCount = (tabId) => {
        if (tabId === tabIds.TOUS) return productsToBeEnriched.length;
        if (tabId === tabIds.METATITLE) return productsToBeEnriched.filter(p => p.attribute === "meta title").length;
        if (tabId === tabIds.METADESC) return productsToBeEnriched.filter(p => p.attribute === "meta desc").length;
        if (tabId === tabIds.DESCRIPTION) return productsToBeEnriched.filter(p => getFieldToEnrich(p) === fields.DESCRIPTION).length;
        if (tabId === tabIds.IMAGE) return productsToBeEnriched.filter(p => [fields.PICTURE, fields.PICTURES].includes(getFieldToEnrich(p))).length;
        return productsToBeEnriched.filter(r => r.attribute === tabId).length;
    };

    function handleActionClick() {
        if (selected.length === 0) {
            alert("Veuillez sélectionner au moins un produit.");
            return;
        }

        setIsPopupOpen(true);
    }

    const handleConfirm = async () => {
        setLoading(true);
        try {
            // selected is now an array of IDs
            const productIds = selected;

            //await aiUpdateDescription(productIds);

            setIsPopupOpen(false);
            if (list && match && match.params && match.params.params) {
                list(decodeURIComponent(match.params.params));
            } else {
                window.location.reload();
            }
        } catch (error) {
            console.error("Error creating description:", error);
            alert("Une erreur est survenue lors de la création de la description.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div style={{width: "100%", marginBottom: '24px'}}>
            <div style={{display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "12px"}}>
                {tabs.map((tab) => (
                    <TabButton
                        key={tab.id}
                        tab={tab}
                        isActive={tab.id === activeId}
                        onClick={() => setActiveId(tab.id)}
                        selectedCount={getDynamicCount(tab.id)}
                    />
                ))}
            </div>

            <ActionPanel
                activeTab={activeTab}
                onActionClick={handleActionClick}
                selectedCount={selected.length}
            />

            <ConfirmationPopup
                open={isPopupOpen}
                handleClose={() => setIsPopupOpen(false)}
                onConfirm={handleConfirm}
                content={(
                    <div>
                        Appliquer <b>« Création de la description »</b> sur  <b>{selected.length} produit(s)</b> ?
                    </div>
                )}
                loading={loading}
                selectedProducts={productsToBeEnriched.filter(p => selected.includes(p.id))}
            />
        </div>
    );
}
